import { useState } from "react";
import { getPropertyTypeText, joinWithDot, isEmpty, getPropertyTypeClass, resolveListingPrice } from "utils/helpers";
import { PropertyMlsStatus } from "./MLSStatus";
import { IPropertyCard, IPropertyMiniCard } from "./PropertyCard.def";
import { differenceInDays } from "date-fns";
import { fetchWrapper } from "services/api-client/fetchWrapper";
import { captureException } from "scripts/logging/error-report";
import { createPortal } from "react-dom";
import { PropertyPopUp } from "components/PropertyPopUp";
import { IconToggle } from "components/IconToggle";
import { useUserContext } from "services/UserContext";
import { AgentInfoCard } from "components/AgentInfoCard";
import { trackEvent } from "services/api-client/matomoTracker";
import { AGENT_FALLBACK_URL } from "utils/constants";

export const PropertyMiniCard = (props: IPropertyMiniCard) => (
  <PropertyCard kind="mini" {...props} />
);

export default function PropertyCard(props: IPropertyCard) {
  const { user } = useUserContext();
  const [showPopUp, setShowPopUp] = useState(false);
  const [showAlertBookmark, setShowAlertBookmark] = useState({
    show: false,
    message: "",
  });
  const [showAlertNotinterested, setShowAlertNotinterested] = useState({
    show: false,
    message: "",
  });
  const { propertyDetails } = props;
  const [bookmark, setbookmark] = useState(propertyDetails?.bookmarked == 1);
  const [notinterested, setnotinterested] = useState(
    propertyDetails?.notinterested == 1
  );
  const connectedAgent = user?.connected_agent;
  const isBrandedApp = !!(user.role === "consumer" && connectedAgent);
  const nameOrEmail = `${connectedAgent?.firstname} ${connectedAgent?.lastname}` || connectedAgent?.email || '';

  if (!propertyDetails) {
    return <></>;
  }

  const beds =
    !isEmpty(propertyDetails?.detailItems?.Bedrooms) &&
    `${propertyDetails?.detailItems.Bedrooms} bed${propertyDetails?.detailItems.Bedrooms == "1" ? "" : "s"
    }`;
  const bath =
    !isEmpty(propertyDetails?.detailItems?.Baths) &&
    `${propertyDetails?.detailItems.Baths} bath${propertyDetails?.detailItems.Baths == "1" ? "" : "s"
    }`;
  const stories = !isEmpty(propertyDetails?.detailItems?.Stories)
    ? `${propertyDetails?.detailItems.Stories} ${propertyDetails?.detailItems.Stories == "1" ? "story" : "stories"
    }`
    : "";
  const buildingSQFT =
    !isEmpty(propertyDetails?.detailItems?.["Building SQFT"]) &&
    `${propertyDetails?.detailItems["Building SQFT"]} Sqft.`;
  const priceSQFT =
    propertyDetails?.detailItems?.["Price per SQFT"] &&
      !isEmpty(propertyDetails.detailItems["Price per SQFT"])
      ? `$${Math.round(
        parseFloat(
          propertyDetails.detailItems["Price per SQFT"].replace("$", "")
        ) || 0
      )}/Sqft.`
      : "";

  const yearBuiltin =
    !isEmpty(propertyDetails?.detailItems?.["Year Built"]) &&
    `${propertyDetails?.detailItems["Year Built"]} year built`;

  const details =
    // "· " +
    joinWithDot(
      propertyDetails?.detailItems?.["Property Type"],
      beds,
      bath,
      stories,
      buildingSQFT,
      priceSQFT,
      yearBuiltin
    );
  const image = propertyDetails.has_photos
    ? propertyDetails.photos.urls[0]
    : "https://content.harstatic.com/media/icons/artwork/no_photo_placeholder__large.svg";
  const imageMiniCard = propertyDetails.photo
    ? propertyDetails.photos.urls[0]
    : "https://content.harstatic.com/media/icons/artwork/no_photo_placeholder__large.svg";
  const days = differenceInDays(new Date(), propertyDetails?.detail?.date);
  const listingStatus = propertyDetails.detailItems?.Status ?? "";
  const typeClass = getPropertyTypeClass(
    propertyDetails?.detail.type ?? "",
    listingStatus
  );
  const typeText = getPropertyTypeText(
    propertyDetails?.detail.type ?? "",
    listingStatus
  );
  const showType = propertyDetails?.detail.status !== "Sold";
  // Sold listings show what they sold for, not what they were listed at - and
  // only if this user is allowed to see the exact figure.
  const displayPrice = resolveListingPrice(
    propertyDetails?.detail?.sold_price_display,
    propertyDetails?.detail?.price
  );
  const realtor = propertyDetails?.realtor;
  const broker = propertyDetails?.broker;
  // const isLoggedin = propertyDetails?.isLogin == 1;
  const isLoggedin = user?.role !== "guest";
  const agentid = propertyDetails?.realtor?.agentid;

  const handleBookmark = async () => {
    try {
      const { message } = !bookmark
        ? await fetchWrapper.post(
          `/api/v1/chatbot/bookmark/${propertyDetails?.mlsnum}`,
          {}
        )
        : await fetchWrapper._delete(
          `/api/v1/chatbot/bookmark/${propertyDetails?.mlsnum}`
        );
      setShowAlertBookmark({ show: true, message: message });
      propertyDetails && setbookmark(!bookmark);
      const event = bookmark ? "Remove Bookmark" : "Bookmark";
      trackEvent(`AI Mode / Listing Assistant ${event} / ${propertyDetails?.harid}`);
      setTimeout(
        () => setShowAlertBookmark({ show: false, message: "" }),
        5000
      );
    } catch (e) {
      captureException(e);
      console.error(e);
    }
  };

  const handleNotinterested = async () => {
    try {
      const { message } = !notinterested
        ? await fetchWrapper.post(
          `/api/v1/chatbot/nointerest/${propertyDetails?.mlsnum}`,
          {}
        )
        : await fetchWrapper._delete(
          `/api/v1/chatbot/nointerest/${propertyDetails?.mlsnum}`
        );
      setShowAlertNotinterested({ show: true, message: message });
      propertyDetails && setnotinterested(!notinterested);
      const event = notinterested ? "Remove Not Interested" : "Not Interested";
      trackEvent(`AI Mode / Listing Assistant ${event} / ${propertyDetails?.harid}`);
      setTimeout(
        () => setShowAlertNotinterested({ show: false, message: "" }),
        5000
      );
    } catch (e) {
      captureException(e);
      console.error(e);
    }
  };

  if (props.kind == "mini") {
    return (
      <>
        {" "}
        <div
          className="cardv2--mini cursor--pointer"
          style={{ maxWidth: "370px", marginLeft: "45px" }}
          onClick={(e) => {
            e.preventDefault();
            setShowPopUp(true);
          }}
        >
          <div className="cardv2--mini__content">
            <div className="cardv2--mini__content__body">
              <a href={propertyDetails.share_url}>
                <div className="cardv2--mini__content__body__image">
                  <div
                    className="cardv2--mini__content__body__image__img bg__bottom"
                    style={{
                      backgroundImage: `url(${imageMiniCard})`,
                    }}
                  />
                </div>
              </a>
              <div className="cardv2--mini__content__body__details">
                <div>
                  <div className="cardv2--mini__content__body__details_address pb-2">
                    <div className="cardv2--mini__content__body__details_address_left overflow-inherit">
                      <div className="cardv2--mini__content__body__details_price pb-0">
                        {" "}
                        {displayPrice.value}
                      </div>
                    </div>
                    <div className="cardv2--mini__content__body__details_address_right">
                      <PropertyMlsStatus
                        mls_status_text={propertyDetails.detailItems.Status}
                      />
                    </div>
                  </div>
                  <div className="">
                    <div className="cardv2--mini__content__body__details_address_left_add">
                      {propertyDetails?.detail?.address}
                      <br />
                      {propertyDetails.detail.city},{" "}
                      {propertyDetails.detail.zip}
                    </div>
                    <div className="cardv2--mini__content__body__details_features">
                      <ul>
                        {!!beds ? <li>{beds}</li> : ""}
                        {!!bath ? <li>{bath}</li> : ""}
                        {!!buildingSQFT ? <li>{buildingSQFT}</li> : ""}
                      </ul>
                    </div>
                    <div className="cardv2--mini__content__body__details_dayson">
                      {/*<div className="circle_nimber">{days}</div> Day{(days??0)>1?"s":""} on HAR */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {showPopUp &&
          createPortal(
            <PropertyPopUp
              harid={propertyDetails.harid}
              id={propertyDetails.id}
              statusShort={propertyDetails.status_short}
              onClose={() => setShowPopUp(false)}
            />,
            document.body
          )}
      </>
    );
  }

  return (
    <span className="mb-2" style={{ whiteSpace: "normal" }}>
      {agentid && (
        <div
          className="border_radius--pudgy p-2 position-relative cardv2--landscape__header"
          style={{ maxWidth: 710, borderBottom: "none", marginBottom: "5px" }}
        >
          <div className="cardv2--landscape__header_agent d-flex align-items-center">
            {isBrandedApp && connectedAgent ? (
              <AgentInfoCard
                agentProfileUrl={connectedAgent?.bioUrl}
                brokerProfileUrl={connectedAgent?.office_url || ''}
                name={nameOrEmail}
                photo={connectedAgent?.photo}
                officeName={connectedAgent?.office_name}
                mlsPlantinum={connectedAgent?.is_platinum}
              />
            ) : (
              <AgentInfoCard
                agentProfileUrl={realtor?.biourl}
                brokerProfileUrl={broker?.officeurl || ''}
                name={realtor?.agentname || ''}
                photo={realtor?.photo || ''}
                officeName={broker?.officename || ''}
                mlsPlantinum={realtor?.mls_plantinum}
              />
            )}
          </div>
          <div className="cardv2--landscape__header_controls">
            {(() => {
              const contactAgentUrl =
                isBrandedApp && connectedAgent
                  ? connectedAgent?.bioUrl
                  : realtor?.biourl;
              return contactAgentUrl && contactAgentUrl !== AGENT_FALLBACK_URL ? (
                <a
                  title="Contact Agent"
                  className="mr-2 cursor--pointer btn btn--ordinary btn--medium"
                  style={{ width: "auto" }}
                  href={`${contactAgentUrl}?contact_agent=1`} // here ?contact_agent=1 is used to open the contact form in new tab, which is implemented in agent profile page on har.com
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact Agent
                </a>
              ) : null;
            })()}
            {propertyDetails?.status_short === "A" && isLoggedin && (
              <>
                <IconToggle
                  onClick={handleNotinterested}
                  title="Mark as not interested"
                  className={`mr-2 btn btn--ordinary cursor--pointer btn--medium btn--icon btn--icon--lone btn--icon--dislike cmd--notint btn--desktoponly ${notinterested ? "btn--icon--disliked" : ""}`}
                />
                <IconToggle
                  onClick={handleBookmark}
                  title="Add to favourites"
                  className={`mr-0 favorite_big_heart cursor--pointer btn btn--ordinary btn--medium btn--icon btn--icon--lone cmd--fav ${bookmark ? "btn--icon--favorited" : "btn--icon--favorite"}`}
                />
              </>
            )}
          </div>
        </div>
      )}
      <div
        className="border_radius--pudgy home_info_box p-2 position-relative"
        style={{ maxWidth: "700px" }}
        onClick={(e) => {
          e.preventDefault();
          setShowPopUp(true);
        }}
      >
        <div className="row no-gutters" style={{ maxWidth: 650 }}>
          <div className="col-auto">
            <a
              className="bg--image border_radius--default mr-4 d-block"
              href={propertyDetails.share_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#212529",
                minWidth: "100px",
                maxWidth: "240px",
                textDecoration: "none",
                backgroundImage: `url(${image})`,
                width: "100%",
                height: "110px",
              }}
              onClick={(e) => e.stopPropagation()}
            ></a>
          </div>
          <div className="col font_size--medium pl-3 pl-md-4">

            <div className="row my-2">
              <div className="col-md-auto col-12 pb-md-0 pb-2 pr-2 font_size--large font_weight--bold">
                {displayPrice.value}
                {displayPrice.sqft && (
                  <span className="font_size--small ml-1 font_weight--regular">
                    {displayPrice.sqft}
                  </span>
                )}
              </div>
              <div className="col-md-auto col-12 p-md-0 d-flex flex-wrap gap-quarter">
                {showType && (
                  <div className={`label label--${typeClass}`}>
                    {typeText}
                  </div>
                )}
                <PropertyMlsStatus
                  mls_status_text={propertyDetails.detailItems.Status}
                />
              </div>
            </div>
            <div
              className="pb-md-2 pb-1 font_weight--bold cursor--pointer truncate-1-line"
              onClick={(e) => {
                e.stopPropagation();
                window.open(propertyDetails.share_url, "_blank", "noopener,noreferrer");
              }}
            >
              {propertyDetails?.detail?.address},{" "}
              {propertyDetails.detail.city}, {propertyDetails.detail.zip}
            </div>
            <div className="font_size--medium font_size--small_sm flex-grow-1">
              {details}
            </div>
          </div>
        </div>
      </div>
    </span>
  );
}
